// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import ClipLoader from 'react-spinners/ClipLoader';
// import { COURSES_URL, ENROLLMENT_URL } from '../../Services/courseService';

// const CategoriesCourses = () => {
//     const [categoryCourse, setCategoryCourse] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);
//     const option = queryParams.get('option');
//     const topic = queryParams.get('topic');

//     useEffect(() => {
//         const fetchCategoryCourses = async () => {
//             if (!option || !topic) {
//                 console.error('Option /topic missing');
//                 return;
//             }

//             setLoading(true);
//             try {
//                 const res = await axios.get(`${COURSES_URL}/course/allFilter?${option}=${topic.toLowerCase()}`);
//                 setCategoryCourse(res.data);
//             } catch (err) {
//                 console.error(err);
//                 setCategoryCourse([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchCategoryCourses();
//     }, [option, topic]);

//     const navigate = useNavigate();

//     const userId = localStorage.getItem('userId');

//     const checkEnrollmentStatus = async (courseId) => {
//         try {
//             const response = await axios.get(`${ENROLLMENT_URL}/${userId}/${courseId}/getEnrollmentStatus`);
//             return response.data;
//         } catch (error) {
//             console.error('Error checking enrollment status:', error);
//         }
//     };

//     const handleViewDetails = async (courseId) => {
//         try {

//             const isEnrolled = await checkEnrollmentStatus(courseId);
//             console.log(isEnrolled)
//             if (isEnrolled) {
//                 navigate(`/enrolledCourse/${courseId}`)
//             }
//             else {
//                 // navigate(`/coursedetails/${courseId}`)
//                 navigate('/courses/:slug')
//             }
//         } catch (error) {
//             console.error('Error saving search history:', error);
//         }
//     };

//     return (
//         <div className="search-results-container">
//             {loading ? (
//                 <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />
//             ) : (

//                 categoryCourse.length > 0 ? (

//                     <div className="search-results-list">
//                         <p className="search-results-title">{topic} Related Courses</p>

//                         {categoryCourse?.map((course) => (
//                             <div className="course-item" key={course.courseId}  onClick={(e) => {
//                                 e.preventDefault();
//                                 handleViewDetails(course.courseId);
//                             }}>
//                                 <div>
//                                     <img src={course.imageUrl} alt={course.title} className='search-results-img' />
//                                 </div>

//                                 <div className='search-course-details-container'>
//                                     <div >
//                                         <h3>{course.title}</h3>
//                                         <p className='description'>{course.description}</p>
//                                         <p>₹{course.price}</p>
//                                     </div>
//                                     <button
//                                         className="enrolledCourse-start-course"
//                                         onClick={(e) => {
//                                             e.preventDefault();
//                                             handleViewDetails(course.courseId);
//                                         }}
//                                     >
//                                         View Details
//                                     </button>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 ) : (
//                     <p className="no-results">No courses found.</p>
//                 )
//             )}
//         </div>
//     );
// };

// export default CategoriesCourses;

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import { COURSES_URL, ENROLLMENT_URL } from '../../Services/courseService';
import { Helmet } from 'react-helmet';
import './CategoriesCourses.css';

const CategoriesCourses = () => {
    const [categoryCourse, setCategoryCourse] = useState([]);
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const option = queryParams.get('option');
    const topic = queryParams.get('topic');

  const normalizedTopic = topic
    ?.toLowerCase()
    .trim()
    .replace(/\+\+/g, 'cpp')
    .replace(/\./g, '');
const seoData = {
    react: {
        title: 'React Courses Online | SkillzVerse',
        description:
            'Explore React courses at SkillzVerse with expert-led training, hands-on projects, practical coding exercises, and job-ready frontend development skills.',
        keywords:
            'React Courses, Learn React,React Online Course,React.js Course,React Training,React Development,Frontend Development Course,React for Beginners,React Certification,React Developer Training',
    h1: 'React Courses to Build Modern Frontend Applications'
        },


    javascript: {
        title: 'JavaScript Courses Online | SkillzVerse',
        description:
            'Explore JavaScript courses at SkillzVerse with expert-led training, hands-on projects, coding exercises, and practical learning to build modern web development skills.',
        keywords:
          'JavaScript Courses,Learn JavaScript,JavaScript Online Course,JavaScript Programming,JavaScript Tutorial,JavaScript Training,Web Development Course,Frontend Development,JavaScrip Certification,JavaScript for Beginners,Online Programming Courses',
     h1: 'JavaScript Courses for Modern Web Development'
        },
    'vuejs': {
    title: 'Vue.js Courses Online | SkillzVerse',
    description:
        'Explore Vue.js courses at SkillzVerse with expert-led training, hands-on projects, practical coding exercises, and job-ready frontend development skills',
    keywords:
        'Vue.js Courses,Learn Vue.js,Vue.js Online Course,Vue.js Training,Vue.js Development,Frontend Development Course,JavaScript Framework,Vue.js for Beginners,Vue.js Certification,Modern Web Development',
  h1: 'Vue.js Courses for Modern Frontend Development'
    },
 python: {
        title: 'Python Courses Online | SkillzVerse',
        description:'Explore Python courses at SkillzVerse with expert-led training, hands-on projects, practical coding exercises, and job-ready programming skills for career growth.',
     keywords:'Python Courses,Learn Python,Python Programming Course,Python Online Course,Python for Beginners,Python Developer Course,Python Certification,Online Programming Courses,Software Development with Python,',
     h1: 'Python Courses to Build Job-Ready Programming Skills'   
    },

        java: {
    title: 'Java Courses Online | SkillzVerse',
    description:
        'Explore Java courses at SkillzVerse with expert-led training, hands-on projects, Core Java concepts, practical coding exercises, and job-ready programming skills.',
    keywords:
        ' Java Courses,Java Course online,Learn Java,Java Programming Course,Java Training,Core Java Course',
  h1: 'Java Courses to Build Job-Ready Programming Skills'
    },
'cpp': {
    title: 'C++ Courses Online | SkillzVerse',
    description:
        'Explore C++ courses at SkillzVerse with expert-led training, hands-on coding, practical projects, and job-ready programming skills for software development.',
    keywords:
        'C++ Courses,C++ Programming Course,Learn C++,C++ Online Course,C++ Training,C++ for Beginners',
 h1: 'C++ Courses to Build Job-Ready Programming Skills'

    },

c: {
    title: 'C Programming Courses | SkillzVerse',
    description:
        'Explore C Programming Courses at SkillzVerse with expert-led training, hands-on coding, practical projects, and job-ready programming skills for software development.',
    keywords:
        'C Programming Courses,C Programming Course,Learn C Programming,C Language Course,C Programming Training,C Programming for Beginners',
    h1: 'C Programming Courses for Beginners and Professionals'
},
go: {
    title: 'Go Programming Courses | SkillzVerse',
    description:
        'Explore Go Programming Courses at SkillzVerse with expert-led training, hands-on coding, practical projects, and job-ready backend development skills.',
    keywords:
        'Go Programming Courses,Learn Go Programming,Go Language Course,Go Programming Tutorial',
    h1: 'Go Programming Courses for Modern Backend Development'
},
microservices: {
    title: 'Microservices Courses Online | SkillzVerse',
    description:
        'Explore Microservices Courses at SkillzVerse with expert-led training, Spring Boot, REST APIs, hands-on projects, and job-ready backend development skills.',
    keywords:
        'Microservices Courses,Microservices Course,Learn Microservices,Spring Boot Microservices,Microservices Architecture,Microservices Training',
    h1: 'Microservices Courses for Modern Backend Development'
},
ides: {
    title: 'IDEs Courses Online | SkillzVerse',
    description:
        'Explore IDEs Courses at SkillzVerse to learn integrated development environments, coding tools, debugging, code editing, and productivity for software development.',
    keywords:
        'IDEs Courses, Integrated Development Environment,Programming IDE,Best IDE for Programming,Learn IDEs,Code Editor for Developers',
h1: 'IDEs Courses for Efficient Software Development'

    },
scaling: {
    title: 'Scaling Courses Online | SkillzVerse',
    description:
        'Explore Scaling Courses at SkillzVerse to learn system design, scalability, distributed systems, performance optimization, and real-world application scaling.',
    keywords:
        'Scaling Courses,System Design Course,Scalability Training,Learn System Design,Application Scaling,Distributed Systems Course',
    h1: 'Scaling Courses for Modern System Design and Scalability'
},
aws: {
    title: 'AWS Courses Online | SkillzVerse',
    description:
        'Explore AWS Courses at SkillzVerse with expert-led training, cloud computing, hands-on labs, AWS certification preparation, and job-ready cloud skills',
    keywords:
        'AWS Courses,AWS Certification Course,AWS Cloud Training,Learn AWS,Cloud Computing Course,AWS Solutions Architect Course',
 h1: 'AWS Courses for Cloud Computing and Certification'
    },
'ethical hacking': {
    title: 'Ethical Hacking Courses Online | SkillzVerse',
    description:
        ' Explore Ethical Hacking Courses at SkillzVerse with expert-led training, penetration testing, cybersecurity labs, hands-on projects, and job-ready security skills.',
    keywords:
        'Ethical Hacking Courses,Ethical Hacking Course,Learn Ethical Hacking,Cyber Security Course,Penetration Testing Course,CEH Training',
 h1: 'Ethical Hacking Courses for Job-Ready Cybersecurity Skills'
    },
'penetration testing': {
    title: 'Penetration Testing Courses | SkillzVerse',
    description:
        'Explore Penetration Testing Courses at SkillzVerse with expert-led training, ethical hacking, VAPT, hands-on labs, and job-ready cybersecurity skills.',
    keywords:'Penetration Testing Courses,Penetration Testing Course,Learn Penetration Testing,Ethical Hacking Course,Cyber Security Training,VAPT Course',
        h1: 'Penetration Testing Courses for Job-Ready Cybersecurity Skills'

},
'soc': {
    title: 'SOC Analyst Courses | SkillzVerse',
    description:
        'Explore SOC Analyst Courses at SkillzVerse with expert-led training, SIEM tools, incident response, threat detection, hands-on labs, and job-ready cybersecurity skills.',
    keywords:
        'SOC Analyst Courses,SOC Analyst Course,Security Operations Center Training,Cyber Security SOC Course,SOC Analyst Training,Incident Response Course',
 h1: 'SOC Analyst Courses for Job-Ready Cybersecurity Professionals'
    },
pr: {
    title: 'Public Relations Courses Online | SkillzVerse',
    description:
        'Explore Public Relations Courses at SkillzVerse with expert-led training, corporate communication, media relations, practical projects, and career-ready PR skills.',
    keywords:
        'Public Relations Courses,Public Relations Course,PR Training,Corporate Communication Course,Public Relations Certification,Media Relations Course',
    h1: 'Public Relations Courses for Corporate Communication Skills'
},
};

const currentSeo = seoData[normalizedTopic] || {
    title: 'Online IT Courses & Programming Training | SkillzVerse',
    description:
        'Explore online IT courses at SkillzVerse with expert-led training in programming, full stack development, AI, cloud computing, and practical career-focused learning.',
    keywords:
        'Online Programming Courses,IT Training Platform,Full Stack Development Courses,Java Programming Course,Python Programming Course,Web Development Courses,AI & Machine Learning Courses,Software Development Training,Career Skill Development,Online Learning Platform,Expert-Led Courses,Skill Development Courses',
h1: 'Learn In-Demand IT Skills with Expert-Led Online Courses'
    };


    const navigate = useNavigate();
    const userId = localStorage.getItem('userId');

   const generateSlug = (title) =>
    title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    useEffect(() => {
        const fetchCategoryCourses = async () => {
            if (!option || !topic) {
                console.error('Option/topic missing');
                return;
            }

            setLoading(true);
            try {
                const res = await axios.get(`${COURSES_URL}/course/allFilter?${option}=${topic.toLowerCase()}`);
                const courses = Array.isArray(res.data) ? res.data : [];

                const slugToIdMap = {};
                const coursesWithSlug = courses.map(course => {
                    const slug = generateSlug(course.title);
                    slugToIdMap[slug] = course.courseId;
                    return { ...course, slug };
                });

                localStorage.setItem('slugCourseMap', JSON.stringify(slugToIdMap));

                setCategoryCourse(coursesWithSlug);
            } catch (err) {
                console.error(err);
                setCategoryCourse([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCategoryCourses();
    }, [option, topic]);

    const checkEnrollmentStatus = async (courseId) => {
        try {
            const response = await axios.get(`${ENROLLMENT_URL}/${userId}/${courseId}/getEnrollmentStatus`);
            return response.data;
        } catch (error) {
            console.error('Error checking enrollment status:', error);
            return false;
        }
    };

    const handleViewDetails = async (courseId, slug) => {
        try {
            const isEnrolled = await checkEnrollmentStatus(courseId);
            if (isEnrolled) {
                navigate(`/enrolledCourse/${courseId}`);
            } else {
                navigate(`/courses/${slug}`);
            }
        } catch (error) {
            console.error('Error handling course view:', error);
        }
    };

const isJavaScript = topic?.toLowerCase() === "javascript";
    
    return (
        <>
 <Helmet>
    <title>{currentSeo.title}</title>

    <meta
        name="description"
        content={currentSeo.description}
    />

    <meta
        name="keywords"
        content={currentSeo.keywords}
    />

    <link
        rel="canonical"
        href={`https://skillzverse.com/categories?option=${encodeURIComponent(option)}&topic=${encodeURIComponent(topic)}`}
    />
</Helmet>


        <div className="search-results-container">
            {loading ? (
                <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />
            ) : categoryCourse.length > 0 ? (

                
                <div className="search-results-list">
                    <h1 className="search-results-title">
    {currentSeo.h1}
</h1>

                    {categoryCourse.map((course) => (
                        <div
                            className="course-item"
                            key={course.courseId}
                            onClick={(e) => {
                                e.preventDefault();
                                handleViewDetails(course.courseId, course.slug);
                            }}
                        >
                            <div>
                                <img src={course.imageUrl} alt={course.title} className='search-results-img' />
                            </div>

                            <div className='search-course-details-container'>
                                <div>
                                    <h3>{course.title}</h3>
                                    <p className='description'>{course.description}</p>
                                    <p>₹{course.price}</p>
                                </div>
                                <button
                                    className="enrolledCourse-start-course"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleViewDetails(course.courseId, course.slug);
                                    }}
                                >
                                    View Details
                                </button>
                            </div>
                        </div>
                    ))}
 </div>



            ) : (
                <p className="no-results">No courses found.</p>
            )}

             {/* React FAQ */}
    {topic?.toLowerCase() === "react" && (
        <section className="react-category-faq">
            <h2>
                Frequently Asked Questions About React Courses
            </h2>

            <div className="react-faq-item">
                <h3>What is React?</h3>
                <p>
                    React is a JavaScript library used to build
                    interactive and dynamic user interfaces,
                    especially for modern web applications.
                </p>
            </div>

            <div className="react-faq-item">
                <h3>Are React courses suitable for beginners?</h3>
                <p>
                    Yes. Beginners can start with React fundamentals
                    and gradually learn components, JSX, props,
                    state, hooks, routing, and application development.
                </p>
            </div>

            <div className="react-faq-item">
                <h3>What should I learn before React?</h3>
                <p>
                    Basic knowledge of HTML, CSS, and JavaScript is
                    recommended before starting React. Understanding
                    JavaScript functions, arrays, objects, ES6 features,
                    and DOM concepts can make learning React easier.
                </p>
            </div>

            <div className="react-faq-item">
                <h3>What will I learn in a React course?</h3>
                <p>
                    React courses can cover components, JSX, props,
                    state, hooks, event handling, API integration,
                    routing, reusable components, and real-world
                    React projects.
                </p>
            </div>

            <div className="react-faq-item">
                <h3>Can I get a job after learning React?</h3>
                <p>
                    Learning React along with JavaScript, HTML, CSS,
                    APIs, Git, and frontend development practices can
                    help you prepare for frontend and React developer
                    roles.
                </p>
            </div>

            <div className="react-faq-item">
                <h3>Is React useful for frontend development?</h3>
                <p>
                    Yes. React is widely used for building modern,
                    component-based frontend applications and
                    interactive user interfaces.
                </p>
            </div>
        </section>
    )}

    {/* Vue.js FAQ */}
    {normalizedTopic === "vuejs" && (
    <section className="vue-category-faq">
        <h2>Frequently Asked Questions About Vue.js Courses</h2>

        <div className="vue-faq-item">
            <h3>What is Vue.js?</h3>
            <p>
                Vue.js is a progressive JavaScript framework used to build
                interactive and dynamic web interfaces and modern frontend
                applications.
            </p>
        </div>

        <div className="vue-faq-item">
            <h3>Are Vue.js courses suitable for beginners?</h3>
            <p>
                Yes. Beginners can learn Vue.js step by step by starting with
                HTML, CSS, JavaScript, Vue components, templates, directives,
                props, events, and state management.
            </p>
        </div>

        <div className="vue-faq-item">
            <h3>What should I learn before Vue.js?</h3>
            <p>
                Basic knowledge of HTML, CSS, and JavaScript is recommended
                before learning Vue.js. Understanding JavaScript fundamentals
                makes it easier to work with Vue components and applications.
            </p>
        </div>

        <div className="vue-faq-item">
            <h3>What will I learn in a Vue.js course?</h3>
            <p>
                A Vue.js course can cover components, templates, directives,
                props, events, computed properties, watchers, routing,
                state management, API integration, and real-world projects.
            </p>
        </div>

        <div className="vue-faq-item">
            <h3>Can I build web applications with Vue.js?</h3>
            <p>
                Yes. Vue.js can be used to build interactive websites,
                single-page applications, dashboards, e-commerce interfaces,
                and other modern frontend applications.
            </p>
        </div>

        <div className="vue-faq-item">
            <h3>Is Vue.js good for frontend development?</h3>
            <p>
                Yes. Vue.js provides a component-based approach that makes it
                easier to create maintainable and interactive frontend
                applications.
            </p>
        </div>

        <div className="vue-faq-item">
            <h3>Can I get a job after learning Vue.js?</h3>
            <p>
                Learning Vue.js along with JavaScript, HTML, CSS, APIs,
                Git, and practical projects can help prepare you for
                frontend development and Vue.js developer roles.
            </p>
        </div>
    </section>
)}
{/* Paython FAQ */}
{topic?.toLowerCase() === "python" && (
    <section className="python-category-faq">
        <h2>Frequently Asked Questions About Python Courses</h2>

        <div className="python-faq-item">
            <h3>What is Python?</h3>
            <p>
                Python is a popular, high-level programming language known
                for its simple syntax, readability, and wide range of
                applications in web development, automation, data science,
                artificial intelligence, and software development.
            </p>
        </div>

        <div className="python-faq-item">
            <h3>Are Python courses suitable for beginners?</h3>
            <p>
                Yes. Python is beginner-friendly because of its simple and
                readable syntax. Beginners can start with basic programming
                concepts and gradually move toward advanced Python development.
            </p>
        </div>

        <div className="python-faq-item">
            <h3>What should I learn before Python?</h3>
            <p>
                No prior programming experience is required to start learning
                Python. Basic computer knowledge and logical thinking are
                helpful, while programming fundamentals can be learned during
                the course.
            </p>
        </div>

        <div className="python-faq-item">
            <h3>What will I learn in a Python course?</h3>
            <p>
                A Python course can cover variables, data types, operators,
                conditions, loops, functions, lists, tuples, dictionaries,
                object-oriented programming, file handling, exception handling,
                modules, and practical Python projects.
            </p>
        </div>

        <div className="python-faq-item">
            <h3>What can I build with Python?</h3>
            <p>
                Python can be used to build web applications, automation
                scripts, APIs, data analysis solutions, machine learning
                applications, AI projects, and various software applications.
            </p>
        </div>

        <div className="python-faq-item">
            <h3>Is Python useful for career development?</h3>
            <p>
                Yes. Python is widely used across software development,
                automation, data science, artificial intelligence, machine
                learning, testing, and backend development, making it a
                valuable programming skill.
            </p>
        </div>

        <div className="python-faq-item">
            <h3>Can I get a job after learning Python?</h3>
            <p>
                Learning Python along with practical projects, databases,
                APIs, Git, and relevant frameworks or technologies can help
                prepare you for roles such as Python developer, backend
                developer, automation tester, and data-focused positions.
            </p>
        </div>
    </section>
)}
{/* JavaScript FAQ */}

            {isJavaScript && (
    <div className="javascript-seo-content">

        {/* Learning Path */}
        <section className="javascript-learning-path">
            <h2>JavaScript Learning Path</h2>

            <p>
                Follow a structured JavaScript learning path from fundamentals
                to advanced web development. Build your programming knowledge
                step by step with practical coding and projects.
            </p>

            <div className="javascript-path-steps">

                <div className="javascript-path-card">
                    <span>1</span>
                    <h3>JavaScript Fundamentals</h3>
                    <p>
                        Learn variables, data types, operators, functions,
                        conditions, loops, arrays and objects.
                    </p>
                </div>

                <div className="javascript-path-card">
                    <span>2</span>
                    <h3>Intermediate JavaScript</h3>
                    <p>
                        Understand DOM manipulation, events, ES6 features,
                        promises, async/await and API integration.
                    </p>
                </div>

                <div className="javascript-path-card">
                    <span>3</span>
                    <h3>Advanced JavaScript</h3>
                    <p>
                        Learn closures, callbacks, modules, advanced
                        asynchronous programming and modern JavaScript concepts.
                    </p>
                </div>

                <div className="javascript-path-card">
                    <span>4</span>
                    <h3>Modern Frontend Development</h3>
                    <p>
                        Apply JavaScript knowledge with React and build
                        real-world frontend applications.
                    </p>
                </div>

            </div>
        </section>


        {/* Beginner to Advanced Progression */}
        <section className="javascript-progression">
            <h2>JavaScript Beginner to Advanced Progression</h2>

            <div className="javascript-levels">

                <div className="javascript-level">
                    <h3>Beginner</h3>
                    <p>
                        Start with JavaScript syntax, variables, data types,
                        operators, functions, loops and basic programming logic.
                    </p>
                </div>

                <div className="javascript-level">
                    <h3>Intermediate</h3>
                    <p>
                        Move into DOM manipulation, events, ES6+, APIs,
                        promises, async/await and modern JavaScript development.
                    </p>
                </div>

                <div className="javascript-level">
                    <h3>Advanced</h3>
                    <p>
                        Master advanced JavaScript concepts and use them to
                        build scalable and modern web applications.
                    </p>
                </div>

            </div>
        </section>


        {/* Related Courses */}
        <section className="javascript-related-courses">
            <h2>Related JavaScript Courses</h2>

            <p>
                Continue your learning journey with JavaScript and related
                frontend development courses available on SkillzVerse.
            </p>

            <div className="javascript-related-links">

                <a href="/courses/javascript-programming">
                    JavaScript Programming Course
                </a>

                <a href="/courses/react-js-development">
                    React JS Development Course
                </a>

                <a href="/courses/frontend-development">
                    Frontend Development Course
                </a>

            </div>
        </section>


        {/* FAQ */}
        <section className="javascript-faq-section">
            <h2>Frequently Asked Questions About JavaScript Courses</h2>

            <div className="javascript-faq-item">
                <h3>What is a JavaScript course?</h3>
                <p>
                    A JavaScript course teaches programming fundamentals,
                    JavaScript syntax, functions, DOM manipulation, APIs,
                    asynchronous programming and modern JavaScript development.
                </p>
            </div>

            <div className="javascript-faq-item">
                <h3>Is JavaScript suitable for beginners?</h3>
                <p>
                    Yes. JavaScript is suitable for beginners because you can
                    start with basic programming concepts and gradually move
                    toward advanced web development.
                </p>
            </div>

            <div className="javascript-faq-item">
                <h3>What can I build with JavaScript?</h3>
                <p>
                    You can build interactive websites, web applications,
                    frontend applications, backend services and full-stack
                    applications using JavaScript.
                </p>
            </div>

            <div className="javascript-faq-item">
                <h3>Should I learn JavaScript before React?</h3>
                <p>
                    Yes. Having a good understanding of JavaScript fundamentals
                    makes it easier to learn React and other JavaScript
                    frameworks.
                </p>
            </div>

            <div className="javascript-faq-item">
                <h3>Can I get a job after learning JavaScript?</h3>
                <p>
                    JavaScript is widely used in web development. Combining
                    JavaScript with frontend frameworks such as React and
                    practical projects can help prepare you for frontend
                    development roles.
                </p>
            </div>

        </section>

    </div>
)}
        </div>
        </>
    );
};
        

export default CategoriesCourses;
